const ICON = {
    Logo: require('../Assets/Icons/logo.png'),
    Profile: require('../Assets/Icons/pexels-pixabay-415829.jpg'),
    Archerboy: require('../Assets/Images/archer-.jpg'),
    Profile2: require('../Assets/Images/bd1-2.jpeg'),

};

export { ICON }